import Component from '@ux/component';
import PropTypes from 'prop-types';

/**
 * Indicator base class.
 *
 * @public
 */
export default class IndicatorBase extends Component {

  /**
   * Will the indicator be shown.
   *
   * @returns {boolean} If the indicator is complete.
   * @public
   */
  active() {
    return !!this.props.icon && !!this.props.background;
  }

}

/**
 * Property validation.
 *
 * @type {Object}
 * @public
 */
IndicatorBase.propTypes = {
  /** Name of the icon to display. */
  icon: PropTypes.string,
  /** Background class to use. */
  background: PropTypes.string
};
